import { Linkedin } from "lucide-react";
import { LogoWordmark } from "./Logo";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#faf9f6] border-t border-[#e6e1d5] px-6 pt-16 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 pb-12 border-b border-[#e6e1d5]">
          <div className="max-w-sm">
            <div className="mb-5">
              <LogoWordmark dark />
            </div>
            <p className="text-sm text-[#45506b] leading-relaxed">
              Financial services compliance consulting &amp; advisory — ensuring regulatory adherence
              and managing compliance risks for institutions across the UK and international markets.
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#a8824f]">Navigate</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {[["Services", "#services"], ["Readiness", "#readiness"], ["Our Team", "#team"], ["Insights", "#insights"], ["Contact", "#contact"]].map(([label, href]) => (
                <button
                  key={href}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => scrollToId(href)}
                  className="text-sm text-[#45506b] hover:text-[#1b2a4e] transition-colors"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#a8824f]">Connect</p>
            <a
              data-testid="footer-linkedin-link"
              href="https://www.linkedin.com/in/janice-acquaah-5a3b0a8/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 text-sm text-[#45506b] hover:text-[#1b2a4e] transition-colors w-fit focus:outline-none focus:ring-2 focus:ring-[#a8824f] rounded"
            >
              <Linkedin size={16} className="text-[#a8824f]" />
              Janice Acquaah · LinkedIn
            </a>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-alt text-[11px] tracking-[0.2em] text-[#8a93a8] uppercase">
            © 2026 ComplyWise Consult
          </p>
          <p className="font-mono-alt text-[11px] tracking-[0.2em] text-[#8a93a8] uppercase">
            Ensuring Regulatory Adherence · Managing Compliance Risks
          </p>
        </div>
      </div>
    </footer>
  );
}
